import { render, staticRenderFns } from "./StacksListItem.vue?vue&type=template&id=28b1ef6c&"
import script from "./StacksListItem.vue?vue&type=script&lang=js&"
export * from "./StacksListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports